import { action } from 'typesafe-actions';
import { NavbarActionTypes } from './types';

export const navbarCollapseToggle = collapsed =>
  action(NavbarActionTypes.NAVBAR_TOGGLE_COLLAPSE, collapsed);
